import chessimg5 from '../../assets/image/chessimg5.jpeg';
import img1 from '../../assets/image/1.jpeg';
import img2 from '../../assets/image/2.jpeg';
import img3 from '../../assets/image/3.jpeg';
import img4 from '../../assets/image/4.jpeg';
import img5 from '../../assets/image/5.jpeg';
import img6 from '../../assets/image/6.jpeg';
import img7 from '../../assets/image/7.jpeg';
import img8 from '../../assets/image/8.jpeg';
import img9 from '../../assets/image/9.jpeg';
import img10 from '../../assets/image/10.jpeg';
import img11 from '../../assets/image/11.jpeg';
import img12 from '../../assets/image/12.jpeg';
import img13 from '../../assets/image/13.jpeg';
import img14 from '../../assets/image/14.jpeg';
import img15 from '../../assets/image/15.jpeg';

const Gallery = () => {
    return (
        <div>
            <main>
                <div class="slider-area ">
                    <div
                        className="single-slider hero-overly slider-height d-flex align-items-center"
                        style={{
                            backgroundImage: `url(${chessimg5})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            height: '400px', // You can adjust height
                        }}
                    >
                        <div class="container">
                            <div class="row">
                                <div class="col-xl-12">
                                    <div class="hero-cap">
                                        <h2>Gallery</h2>
                                        <nav aria-label="breadcrumb">
                                            <ol class="breadcrumb">
                                                <li class="breadcrumb-item"><a href="index.php">Home</a></li>
                                                <li class="breadcrumb-item"><a href="#">Gallery</a></li>
                                            </ol>
                                        </nav>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div>
                        <div>
                            <div class=" row py-5">
                                <div class="col-lg-4 col-md-12 mb-4 mb-lg-0">
                                    <img src={img1} class="w-100 shadow-1-strong rounded mb-4" alt="" />

                                    <img src={img2} class="w-100 shadow-1-strong rounded mb-4" alt="" />
                                    <img src={img3} class="w-100 shadow-1-strong rounded mb-4" alt="" />
                                    <img src={img4} class="w-100 shadow-1-strong rounded mb-4" alt="" />

                                </div>

                                <div class="col-lg-4 mb-4 mb-lg-0">
                                    <img src={img6} class="w-100 shadow-1-strong rounded mb-4" alt="" />
                                    <img src={img7} class="w-100 shadow-1-strong rounded mb-4" alt="" />
                                    <img src={img8} class="w-100 shadow-1-strong rounded mb-4" alt="" />
                                    <img src={img9} class="w-100 shadow-1-strong rounded mb-4" alt="" />
                                    <img src={img10} class="w-100 shadow-1-strong rounded mb-4" alt="" />
                                </div>

                                <div class="col-lg-4 mb-4 mb-lg-0">
                                    <img src={img11} class="w-100 shadow-1-strong rounded mb-4" alt="" />

                                    <img src={img12} class="w-100 shadow-1-strong rounded mb-4" alt="" />
                                    <img src={img13} class="w-100 shadow-1-strong rounded mb-4" alt="" />
                                    <img src={img14} class="w-100 shadow-1-strong rounded mb-4" alt="" />
                                    <img src={img15} class="w-100 shadow-1-strong rounded mb-4" alt="" />
                                    <img src={img5} class="w-100 shadow-1-strong rounded mb-4" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>

               

                    <div id="back-top" style={{ textAlign: 'center' }}>
                        <a title="Go to Top" href="#" style={{ display: 'inline-block' }}>
                            <i className="fas fa-level-up-alt"></i>
                        </a>
                    </div>
                </div>
            </main>
        </div>
    );

}

export default Gallery